/** Path segments after the module's own segment; empty when the path is outside the module. */
export function segmentsAfter(pathname: string, moduleRoute: string): string[] {
  const segments = pathname.split('/').filter(Boolean);
  const index = segments.indexOf(moduleRoute);
  return index === -1 ? [] : segments.slice(index + 1);
}
